import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1b1818b7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bottom-button-wrap" }



export default /*#__PURE__*/_defineComponent({
  props: {
  type: {
    type: String,
    default: 'primary' //primary plain transparant
  },
  nativeType: {
    type: String,
    default: 'submit' //submit form表单提交
  },
  plain: {
    type: Boolean,
    default: false
  }
},
  setup(__props) {

const props = __props



return (_ctx: any,_cache: any) => {
  const _component_van_button = _resolveComponent("van-button")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_van_button, {
        class: _normalizeClass(["bottom-button", __props.plain == true ? 'plain' : '']),
        round: "",
        block: "",
        type: __props.type,
        "native-type": __props.nativeType
      }, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      }, 8, ["type", "class", "native-type"])
    ]),
    _createElementVNode("div", {
      class: "bottom-button-zhanwei",
      onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
    })
  ]))
}
}

})